import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { CustomToastComponent } from "@/components/shared";
import { useMutation } from "@apollo/client/react";
import {
  EditMobileServiceMutation,
  EditMobileServiceMutationVariables,
  EditMobileServiceDocument,
  FetchTenderByIdDocument,
  FetchServicesOnTenderDocument,
} from "@/graphql/__generated__/graphql";

export default function useEditMobileServiceMutationHook(options?: {
  disableToast?: boolean;
  disableRefetch?: boolean;
}): { editMobileServiceMutation: any; loading: any; error: any } {
  const { t } = useTranslation(["toasts"]);
  const { tenderID } = useParams<{ tenderID: string }>();

  const [editMobileServiceMutation, { loading, error }] = useMutation<EditMobileServiceMutation, EditMobileServiceMutationVariables>(
    EditMobileServiceDocument, {
      onCompleted() {
        if (!options?.disableToast) {
          toast(CustomToastComponent, {
            toastId: "mobile-service-updated-success",
            data: {
              title: t("toasts.mobileserviceupdated"),
              type: "success",
            },
          });
        }
      },
      refetchQueries: options?.disableRefetch
        ? []
        : [
          {
            query: FetchTenderByIdDocument,
            variables: { id: Number(tenderID) },
          },
          {
            query: FetchServicesOnTenderDocument,
            variables: { tenderId: Number(tenderID) },
          },
        ],
    });

  return {
    editMobileServiceMutation,
    loading,
    error,
  };
}
